import { getPage } from "./getPage";

export const getProduct = (products, containerType) => {
  const getRandomInt = (min, max) => Math.floor(Math.random() * (max - min + 1)) + min;

  let productHTML = '';
  let numProducts;

  if (containerType === 'ha-product__content') {
    numProducts = 5;
    const randomProducts = [];
    while (randomProducts.length < numProducts) {
      const randomIndex = getRandomInt(0, products.length - 1);
      const randomProduct = products[randomIndex];
      if (!randomProducts.some(product => product.sku === randomProduct.sku)) {
        randomProducts.push(randomProduct);
      }
    }
    productHTML = randomProducts.map(product => `
      <div class="ha-product__box get_product" data-order-type="${product.sku}">
        <img src="/static/common/shared/products/${product.templates.imageLink}" alt="${product.templates.title}">
        <div class="ha-product__info">
          <div class="ha-product__name">${product.templates.title}</div>
          <div class="ha-product__price">${window.options?.currency ? window.options.currency : '$'}${product.price}</div>
        </div>
      </div>
    `).join('');
  } else if (containerType === 'home-product__content') {
    numProducts = products.length;
    productHTML = products.map(product => `
      <div class="home-product__box get_product" data-order-type="${product.sku}">
        <img src="/static/common/shared/products/${product.templates.imageLink}" alt="${product.templates.title}">
        <span>${product.templates.title}</span>
      </div>
    `).join('');
  }else if (containerType === 'product-list') {
    numProducts = products.length;
    productHTML = products.map(product => `
       ${product.templates.title} <br>
       ${product.templates.title.toUpperCase()} BOTTLE - ${window.options?.currency ? window.options.currency : '$'}${product.price}<br> <br>
    `).join('');
  } else if (containerType === 'ap-content') {
    numProducts = products.length;
    productHTML = products.map(product => `
      <div class="ap-item get_product" data-order-type="${product.sku}">
        <div  class="ap-item__img">
          <img src="/static/common/shared/products/${product.templates.imageLink}" alt="${product.templates.title}">
        </div>
        <div class="ap-item__name">${product.templates.title}</div>
        <div class="ap-item__price">${window.options?.currency ? window.options.currency : '$'}${product.price}</div>
      </div>
    `).join('');
  } else if (containerType === 'banner-flex') {
    numProducts = 4;
    const randomProducts = [];
    while (randomProducts.length < numProducts) {
      const randomIndex = getRandomInt(0, products.length - 1);
      const randomProduct = products[randomIndex];
      if (!randomProducts.some(product => product.sku === randomProduct.sku)) {
        randomProducts.push(randomProduct);
      }
    }
    productHTML = randomProducts.map(product => `
      <div class="banner-box">
        <div class="banner-box__img">
          <img src="/static/common/shared/products/${product.templates.imageLink}" alt="${product.templates.title}">
        </div>
        <div class="banner-box__body">
          <div class="banner-box__name">${product.templates.title}</div>
          <div class="banner-box__button get_product" data-order-type="${product.sku}">GO TO SHOP</div>
        </div>
      </div>
    `).join('');
  }

  $(`.${containerType}`).html(productHTML);


  $('.get_product').click(function (e) {
    const $target = $(e.currentTarget);
    const sku = $target.data('order-type');
    localStorage.setItem('product', sku);

    window.location.href = `${getPage ('product')}&id=${sku}`
  });
};
